import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _size from "lodash/size";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { colors } from '@datacamp/waffles-tokens';
import * as React from 'react';
import { Droppable as DroppableDnd } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import Items from './Items';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Droppable = _ref => {
  let {
    droppableId,
    extraClass,
    innerContainerRefCallback,
    items,
    languageOfTarget,
    maxOffset,
    overrideDropStyle,
    setItemOffset,
    title
  } = _ref;
  const {
    t
  } = useTranslation();
  const getDropStyle = function (isEmptyTarget, isDraggingOver) {
    let overrideStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (isEmptyTarget) {
      return _objectSpread({
        border: isDraggingOver ? "2px dashed ".concat(colors.navy) : "2px dashed rgba(5, 25, 45, 0.3)",
        // colors.navy at 0.3 opacity
        color: colors.navy,
        height: '100%',
        marginTop: 16,
        minHeight: '192px',
        overflow: 'hidden',
        padding: '8px 8px 0px 8px',
        width: '100%'
      }, overrideStyle);
    }
    return _objectSpread({
      border: isDraggingOver ? "2px dashed ".concat(colors.navy) : "2px dashed rgba(5, 25, 45, 0.3)",
      // colors.navy at 0.3 opacity
      height: '100%',
      marginTop: 16,
      minHeight: '192px',
      overflow: 'hidden auto',
      padding: '8px 8px 0px 8px',
      width: '100%'
    }, overrideStyle);
  };
  const isEmpty = _size(items) === 0;
  return ___EmotionJSX("div", {
    className: "".concat(extraClass, " dc-u-fx dc-u-fx-fdc dc-u-fx-aic dc-u-p-12 droppable-container"),
    "data-cy": "droppable-container",
    ref: innerContainerRefCallback
  }, title, ___EmotionJSX(DroppableDnd, {
    droppableId: droppableId
  }, (provided, snapshot) => ___EmotionJSX("div", {
    className: "dc-u-brad-all dc-u-maxw-640 droppable-area ".concat(snapshot.isDraggingOver ? 'is-dragging-over' : ''),
    "data-cy": "droppable-area",
    ref: provided.innerRef,
    style: getDropStyle(isEmpty, snapshot.isDraggingOver, overrideDropStyle)
  }, ___EmotionJSX(Items, {
    items: items,
    languageOfTarget: languageOfTarget,
    maxOffset: maxOffset,
    setItemOffset: setItemOffset
  }), isEmpty && ___EmotionJSX("span", {
    className: "dc-u-fx dc-u-fx-aic dc-u-fx-jcc dc-u-h-100pc"
  }, t('Droppable.empty')), provided.placeholder)));
};
export default Droppable;